import { Eye, Music, MicVocal, Hand } from "lucide-react";
import { Reveal } from "../components/Reveal";

const pillars = [
  { icon: Eye, title: "Sehen", text: "Hochwertige Illustrationen und klare Motive.", color: "#D95338", soft: "#FDF2EF" },
  { icon: Music, title: "Hören", text: "Ein eigener Lernsong passend zur Lernwelt.", color: "#3A7BD5", soft: "#EEF4FC" },
  { icon: MicVocal, title: "Mitsingen", text: "Einfache Wörter und wiederkehrende Melodien.", color: "#E5A93C", soft: "#FCF7EB" },
  { icon: Hand, title: "Mitmachen", text: "Zeigen, klatschen, bewegen und gemeinsam entdecken.", color: "#4A8B5D", soft: "#F0F6F2" },
];

export const Pillars = () => (
  <section className="py-24 sm:py-32" id="was-ist-visualma" data-testid="pillars-section">
    <div className="max-w-6xl mx-auto px-5 lg:px-8">
      <div className="grid lg:grid-cols-[1fr_1.2fr] gap-12 lg:gap-20 items-start mb-16">
        <Reveal>
          <p className="eyebrow-label mb-5">Was ist VisualMA?</p>
          <h2 className="font-display font-medium tracking-tight text-4xl sm:text-5xl leading-[1.08]">
            Mehr als <em style={{ color: "var(--terra)" }}>ein Buch.</em>
          </h2>
          <p className="font-display italic text-lg mt-6 text-[color:var(--ink)]">
            VisualMA Lernwelten verbinden Sehen, Hören und Mitmachen.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="text-[15px] sm:text-base text-[color:var(--ink-muted)] leading-relaxed space-y-4">
            <p>VisualMA entwickelt kleine Lernwelten, die mehrere Sinne miteinander verbinden.</p>
            <p>
              Kinder entdecken klare Illustrationen und einfache Wörter. Passende Lernlieder greifen
              dieselben Inhalte wieder auf. Gemeinsam kann gezeigt, gesprochen, gesungen und sich
              bewegt werden.
            </p>
            <p className="font-medium text-[color:var(--ink)]">
              So entsteht aus wenigen Minuten eine kleine gemeinsame Entdeckungszeit.
            </p>
          </div>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {pillars.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.1}>
            <div
              className="card-soft p-7 h-full transition-transform duration-500 hover:-translate-y-1.5"
              data-testid={`pillar-${p.title.toLowerCase()}`}
            >
              <span
                className="w-12 h-12 rounded-2xl flex items-center justify-center mb-5"
                style={{ background: p.soft, color: p.color, borderRadius: "56% 44% 52% 48% / 46% 54% 46% 54%" }}
              >
                <p.icon size={22} />
              </span>
              <p className="text-[11px] uppercase tracking-[0.22em] font-semibold mb-2" style={{ color: p.color }}>
                {p.title}
              </p>
              <p className="text-sm text-[color:var(--ink-muted)] leading-relaxed">{p.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
